module.exports = __webpack_public_path__ + "static/media/ic_carEnabledCircled.66461d71.svg";